import { josa } from 'es-hangul';
import React from 'react';
import { UseFormRegister } from 'react-hook-form';

interface MemberSelectProps {
  id: string;
  label: string;
  members: any[];
  currentUser: any;
  register: UseFormRegister<any>;
  name: string;
  error?: string;
  excludeId?: string;
  required?: boolean;
  placeholder?: string;
}

const MemberSelect: React.FC<MemberSelectProps> = ({
  id,
  label,
  members,
  currentUser,
  register,
  name,
  error,
  excludeId,
  required = true,
  placeholder
}) => {
  // 필요한 멤버 필터링
  const filteredMembers = excludeId 
    ? members?.filter(member => member.id !== excludeId) 
    : members;

  return (
    <div>
      <label>
        {label}
      </label>
      <select
        id={id}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:border-blue-500" 
        {...register(name, { required: required ? `${josa(label, '을/를')} 선택해주세요` : false })}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {filteredMembers?.map((member) => (
          <option 
            key={member.id} 
            value={member.id}
          >
            {member.user_name} {member.user_id === currentUser?.id ? '(나)' : ''}
          </option>
        ))}
      </select>
      {error && <p className="mt-1 ml-2 text-sm text-red-500">{error}</p>}
    </div>
  );
};

export default MemberSelect; 